






































import Vue from 'vue'
import style from './style.module.scss'

import inputSuggestions from '@/components/controls/dadata/input-suggestions.vue'

export default Vue.extend({
name: 'inn-selector',
  components: {
    inputSuggestions
  },
  props: {
    value: String,
    error: Boolean
  },
  data() {
    return {
      s: style,
      hideInnSuggestion: true,
      foundDadataItems: true,
      dadataEnable: false
    }
  },
  methods: {
    emitNotFound() {
      this.$emit('not-found');
      this.foundDadataItems = true
    },
    onSelectOrg(data: {}) {
      this.foundDadataItems = true;
      this.$emit('select', data);
    },

    handleNotFoundItems(){
      this.foundDadataItems = false;
      this.$forceUpdate();
    },
    handleFoundItems(){
      if (this.dadataEnable == false){
        this.dadataEnable = true;
      }

      if (this.foundDadataItems == false){
        this.foundDadataItems = true;
        this.$forceUpdate();
      }
    },
    handleDadataError(){
      this.foundDadataItems = false;
    },
    handleFocusInn(){
      this.hideInnSuggestion = false;
    }
  }
})
